import { getLabel } from "../../internals/getLabel.js";
const legendGetter = params => {
  const {
    seriesOrder,
    series
  } = params;
  return seriesOrder.reduce((acc, seriesId) => {
    series[seriesId].data.forEach((item, dataIndex) => {
      const formattedLabel = getLabel(item.label, 'legend');
      if (formattedLabel === undefined) {
        return;
      }
      const id = item.id ?? dataIndex;
      acc.push({
        type: 'pie',
        markType: item.labelMarkType ?? series[seriesId].labelMarkType,
        seriesId,
        id,
        itemId: id,
        dataIndex,
        color: item.color,
        label: formattedLabel
      });
    });
    return acc;
  }, []);
};
export default legendGetter;